import axios from 'axios';
import system_url from '../config/system_url'
import Storage from '../utils/storage'
import { message, Modal } from 'ant-design-vue'
import $router from '../../router'
const base_url = system_url.base_url
const auth_key = system_url.auth_key

//判断当前环境切换全局url
axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? base_url.development : base_url.production;

//设置请求超时
axios.defaults.timeout = 30000;

//Post请求头设置
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断storage中是否存在token        
        // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 
        const token = Storage.getStorage('token');
        token && (config.headers[auth_key] = token);
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        const result = response.data
        switch (result.code) {
            //成功
            case 200:
                if (process.env.NODE_ENV !== 'production') {
                    console.log("请求成功！");
                }
                break;
                
            // 404请求不存在
            case 404:
                if (process.env.NODE_ENV !== 'production') {
                    message.error('网络请求不存在', 1.5);
                }
                break;
            // 其他错误，直接抛出错误提示
            default:
                if (process.env.NODE_ENV !== 'production') {
                    message.error(result.msg, 1.5);
                }else{
                    message.error(result.msg, 1.5);
                }
        }
        return result
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码    
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        if (process.env.NODE_ENV !== 'production') {
            console.log("[error]", error);
        }
        message.error('请求失败！', 1.5);
        return Promise.reject(error)
    }
);